import FetchAiCostSummary from '@Application/AiCosts/Queries/FetchAiCostSummary';
import fetchAiCostSummary from '@Application/AiCosts/fetchAiCostSummary';
import { useDispatch, useStoreQuery } from '@verclam/synapse';

/**
 * Reads the cost summary of one account for the given query params, fetching it when the store does
 * not hold it yet. While `isEnabled` is false nothing is fetched; the selector still returns whatever
 * the store holds under that key.
 */
const useAiCostSummary = (accountId: number, queryParams: URLSearchParams, isEnabled: boolean) => {
	const dispatch = useDispatch();
	const key = queryParams.toString();

	return useStoreQuery({
		selector: (state) => state.aiCostsStore.summaries[key] ?? null,
		stopOn: (summary) =>
			!isEnabled || (summary !== null && summary.accountId === accountId && summary.queryKey === key),
		query: () => {
			if (!isEnabled) {
				return Promise.resolve();
			}

			return dispatch(fetchAiCostSummary(new FetchAiCostSummary(accountId, queryParams)));
		},
		deps: [accountId, key],
	});
};

export default useAiCostSummary;
